import ErrorActions from '../actions/errorActions';

function errorReducer(state = {
    buttonDisable : false,
    buttonEnable : false
}, action) {

    switch(action.type){
        case ErrorActions.buttonDisable :
            return {
                buttonDisable : true,
            }
        case ErrorActions.buttonEnable :
            return {
                buttonEnable : true,
                buttonDisable : false,
            }
        default:
            return state;
    }
}

export default errorReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/errorreducer.js